import { QueryClient } from "@tanstack/react-query";
import { isTransientApiError } from "./errors";

// TSQ 는 apiClient 위의 서버상태 캐시 계층이다. 전송·에러 정규화·401 refresh·Sentry 캡처(요청당 1회)는
// apiClient.request 래퍼가 담당하므로 QueryCache/MutationCache onError 에 Sentry 를 붙이지 않는다(이중 보고).
const TRANSIENT_RETRY_LIMIT = 1;

// 기본 retry(3회·지수 백오프)는 business/http 4xx 까지 재시도해 실패를 3배로 늘린다.
// 일시 장애(network/timeout)만 1회 재시도 — apiClient 호출 횟수가 줄어 Sentry 노이즈도 함께 준다.
const retryTransientOnly = (failureCount: number, error: unknown): boolean =>
  isTransientApiError(error) && failureCount < TRANSIENT_RETRY_LIMIT;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // WebView 는 앱 전환·네이티브 시트·키보드마다 visibility 가 튀어 focus refetch 가 노이즈 — off.
      refetchOnWindowFocus: false,
      retry: retryTransientOnly,
      // staleTime(0)·gcTime(5분)·refetchOnReconnect(true) 는 TSQ 기본 유지.
      // staleTime 은 쿼리마다 데이터 성격에 맞춰 명시한다 (docs/project-architecture.md §4).
    },
  },
});
